export const XLSX_HEADERS_CONFIG = {
  veridoc: [
    { header: "SESSION ID", key: "session_id" },
    { header: "PERSON ID", key: "person_id" },
    { header: "FIRST NAME", key: "first_name" },
    { header: "MIDDLE NAME", key: "middle_name" },
    { header: "LAST NAME", key: "last_name" },
    { header: "IIN", key: "iin" },
    { header: "ERROR", key: "error" },
    { header: "TIMESTAMP (UTC+6)", key: "timestamp" }
  ],
  veriface: [
    { header: "SESSION ID", key: "session_id" },
    { header: "PERSON ID", key: "person_id" },
    { header: "SIMILARITY", key: "similarity" },
    { header: "TIMESTAMP (UTC+6)", key: "timestamp" }
  ],
  verilive: [
    { header: "SESSION ID", key: "session_id" },
    { header: "PERSON ID", key: "person_id" },
    { header: "STATUS", key: "status" },
    { header: "TIMESTAMP (UTC+6)", key: "timestamp" }
  ],
  transactions: [
    { header: "person_id", key: "person_id", width: 15 },
    { header: "flow_id", key: "flow_id", width: 30 },
    { header: "service_name", key: "service_name" },
    { header: "service_status", key: "service_status" },
    { header: "error_code", key: "error_code", width: 20 },
    { header: "session_status", key: "session_status" },
    { header: "created_at", key: "created_at", width: 20 },
    { header: "ended_at", key: "ended_at", width: 20 },
    { header: "frontend_session_status", key: "frontend_session_status", width: 20 }
  ],
  statistics: [
    { header: "Total number of flows", key: "total_count" },
    { header: "Started Flows", key: "started_count" },
    { header: "Created flows", key: "created_count" },
    { header: "Succeed flows", key: "ended_count" },
    { header: "Failed flows", key: "failed_count" }
  ],
  signing_sessions: [
    { header: "person_id", key: "person_id", width: 15 },
    { header: "flow_id", key: "flow_id", width: 30 },
    { header: "service_name", key: "service_name" },
    { header: "action", key: "action" },
    { header: "session_id", key: "session_id", width: 20 },
    { header: "session_status", key: "session_status" },
    { header: "error_code", key: "error_code", width: 20 },
    { header: "error_message", key: "error_message", width: 30 },
    { header: "created_at", key: "created_at", width: 20 }
  ],
  signing_statistics: [
    { header: "Success unique flows", key: "success_unique_flows", width: 15 },
    { header: "Total sign sessions", key: "total_sessions", width: 15 },
    { header: "Success sign sessions", key: "success_sessions", width: 15 },
    { header: "Failed sign sessions", key: "failed_sessions", width: 15 }
  ]
};